import { AuthStateType } from "../../UserReducer"
import { ActionType } from "../../Actions"
import { DEVICE_TOKEN } from "../../Actions/Auth/deviceTokenAction";
import { storageKeyAuth } from "../../../model/StorageKeys";
import storeState from "../../../utils/storeState";

export default function deviceTokenReducer(
  state: AuthStateType,
  action: ActionType
): AuthStateType {
  if (action?.type === DEVICE_TOKEN) {
    storeState(storageKeyAuth, action.payload);

    return {
      ...state,
      token: action.payload?.accessToken,
      tokens: action.payload,
    };
  }

  return state;
}
